<template>
    <div class="list-field">
        <label v-if="field.templateOptions.label" class="list-field-label">{{field.templateOptions.label}}</label>
        <span v-on:click="pushNew()" class="glyphicon glyphicon-plus list-field-add"></span>
        <draggable class="list-field-draggable-sort" v-model="model[field.key]" :options="{ handle: '.handle'}"
                   @start="drag=true" @end="drag=false">
            <div class="list-field-item" v-for="(modelinstance, index) in model[field.key]">
                <formly-form :form="form" :model="model" :fields="getSubfields(index)"></formly-form>
                <span class="glyphicon glyphicon-resize-vertical handle"></span>
            </div>
        </draggable>
    </div>
</template>

<script>
    import baseField from 'vue-formly-bootstrap/src/fields/baseField'

    export default {
        mixins: [baseField],
        props: ['form', 'field', 'model'],
        name: 'listRepeater',
        data () {
            return {subfields: []}
        },
        methods: {
            pushNew () {
                this.model[this.field.key].push(this.field.defaultObject !== undefined ? JSON.parse(JSON.stringify(this.field.defaultObject)) : {})
                this.$forceUpdate()
            },
            getSubfields (index) {
                if (this.subfields[index] !== undefined) {
                    return this.subfields[index]
                } else {
                    this.subfields[index] = JSON.parse(JSON.stringify(this.field.subfields))
                    for (let subfield in this.subfields[index]) {
                        this.subfields[index][subfield].key = this.field.key + '[' + index + '].' + this.subfields[index][subfield].key
                    }
                    return this.subfields[index]
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ListRepeater.vue?3d728e6d